const deliveryDate = 'DD MMM';
export default {
  deliveryDate
};

import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18next';

import {ExpressTimeFrame} from 'types';

dayjs.extend(buddhistEra);
dayjs.extend(utc);
dayjs.extend(timezone);

const DEFAULT_TIMEZONE = 'Asia/Bangkok';

const formatDate =
  (dateFormat: string | undefined) =>
  (date: dayjs.ConfigType | undefined): string => {
    const currentLang = i18n?.language;
    return currentLang == 'th'
      ? dayjs(date).tz(DEFAULT_TIMEZONE).locale('th').format(dateFormat?.replace('YYYY', 'BBBB'))
      : dayjs(date).tz(DEFAULT_TIMEZONE).locale('en').format(dateFormat);
  };

function basketDeliveryDateFormat(startDate: dayjs.ConfigType, endDate: dayjs.ConfigType) {
  const locale = i18n?.language === 'th' ? 'th' : 'en';
  const yearFormat = i18n?.language === 'th' ? 'BBBB' : 'YYYY';

  const start = dayjs(startDate).tz(DEFAULT_TIMEZONE).locale(locale);
  const end = dayjs(endDate).tz(DEFAULT_TIMEZONE).locale(locale);

  const startDay = start.format('D');
  const endDay = end.format('D');

  const startMonth = start.format('MMM');
  const endMonth = end.format('MMM');

  const startYear = start.format(yearFormat);
  const endYear = end.format(yearFormat);

  if (startMonth === endMonth) {
    // Case 1: No month overlapping
    return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
  } else if (startYear === endYear) {
    // Case 2: Month overlapping
    return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
  } else {
    // Case 3: Year overlapping
    return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
  }
}

function basketDeliveryBy(startDate: dayjs.ConfigType, endDate: dayjs.ConfigType): string {
  return basketDeliveryDateFormat(startDate, endDate);
}

const isPeriodPassed = (date: dayjs.Dayjs, periodInDays: number): boolean => {
  const today = dayjs();
  const differenceInDay = today.diff(date, 'days');
  return differenceInDay >= periodInDays;
};

const isTimeEligibleForExpress = (timeFrame: ExpressTimeFrame): boolean => {
  const currentHour = dayjs().tz(DEFAULT_TIMEZONE).hour();
  return timeFrame?.from <= currentHour && currentHour <= timeFrame?.to;
};

const getHMMHour = (hour: number) => dayjs().set('hour', hour).set('minute', 0).format('H:mm');

export {formatDate, isPeriodPassed, basketDeliveryDateFormat, basketDeliveryBy, isTimeEligibleForExpress, getHMMHour};
